module.exports = __webpack_public_path__ + "resources/image_loading.0cf6e95c52a7d226.png";